import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiShieldAlertOutline, mdiCogOutline } from "@mdi/js";
import { SAMPLE_REPORT_URL } from "../../constants/global-constants";
import "./disclaimerHowItWorksModal.css";

const DisclaimerHowItWorksModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="disclaimer-how-it-works-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>How Disclaimer Setting Works</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-1 px-2">
          <div className="d-flex flex-column gap-4 p-0">
            {/* Content Appears in Reports Section */}
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiShieldAlertOutline}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <p className="mb-0">
                  The content you edit here will appear in the{" "}
                  <strong>'Inspection Scope & Disclaimer'</strong> section of
                  all future reports you compile.{" "}
                  <a
                    href={SAMPLE_REPORT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary"
                    style={{ textDecoration: "underline" }}
                  >
                    See sample report
                  </a>
                </p>
              </div>
            </div>

            {/* Hide or Show Section */}
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiCogOutline}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <p className="mb-0">
                  You can choose to show or hide this section for all future
                  reports.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default DisclaimerHowItWorksModal;
